var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
import { Alert } from 'reactstrap';
var HIDE_DELAY = 5000;
/**
 *
 */
var AlertNotification = /** @class */ (function (_super) {
    __extends(AlertNotification, _super);
    /**
     *
     * @param props
     */
    function AlertNotification(props) {
        var _this = _super.call(this, props) || this;
        _this.close = _this.close.bind(_this);
        _this.updateCountDown = _this.updateCountDown.bind(_this);
        var now = new Date();
        _this.state = {
            show: true,
            countDownPercentage: 1,
            startTime: now.getTime()
        };
        if (_this.props.autoClose) {
            _this.startCountDown();
        }
        return _this;
    }
    AlertNotification.prototype.componentDidMount = function () {
        this.setState({ mounted: true });
    };
    /**
     *
     */
    AlertNotification.prototype.componentWillUnmount = function () {
        clearInterval(this.countDownInterval);
        this.setState({ mounted: false });
    };
    /**
     *
     * @return {*}
     */
    AlertNotification.prototype.render = function () {
        var timerStyle = { width: (this.state.countDownPercentage) * 100 + '%' };
        return (React.createElement(Alert, { color: this.props.color, isOpen: this.state.show, toggle: this.close },
            React.createElement("div", { dangerouslySetInnerHTML: { __html: this.props.message } }),
            this.props.autoClose ? (React.createElement("div", { className: "alert__timer", style: timerStyle })) : null));
    };
    /**
     *
     */
    AlertNotification.prototype.startCountDown = function () {
        this.countDownInterval = setInterval(this.updateCountDown, 60 / 1000);
        this.updateCountDown();
    };
    /**
     *
     */
    AlertNotification.prototype.updateCountDown = function () {
        var now = new Date();
        var percentage = Math.max(0, Math.min(1, (HIDE_DELAY - (now.getTime() - this.state.startTime)) / HIDE_DELAY));
        if (this.state.mounted) {
            this.setState({ countDownPercentage: percentage });
            if (percentage <= 0) {
                this.close();
            }
        }
    };
    /**
     *
     */
    AlertNotification.prototype.close = function () {
        clearInterval(this.countDownInterval);
        this.setState({ show: false });
        this.props.onClosed(this);
    };
    AlertNotification.defaultProps = {
        mounted: false,
        color: 'info',
        autoClose: true,
        onClosed: function () {
        }
    };
    return AlertNotification;
}(React.Component));
export default AlertNotification;
